import styled, { css } from 'styled-components';

const cssCalendarButton = css`
  background: none;
  border-radius: 6px;

  &:link {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &:focus {
    background-color: rgba(255, 255, 255, 0.05);
  }
`;

export const Container = styled.div`
  position: relative;

  .react-calendar {
    width: 100%;
    border-width: 0;
    background: none;
  }

  .react-calendar__navigation {
    display: flex;
    height: 24px;
  }

  .react-calendar__navigation > button {
    border-radius: 6px;

    ${cssCalendarButton};
  }

  .react-calendar__navigation > .react-calendar__navigation__label {
    border-radius: 6px;
    color: ${({ theme }) => theme.palette.grayscale300};
    ${({ theme }) => theme.typography('$headline_01')};

    ${cssCalendarButton};

    &:hover {
      background: none !important;
    }
  }

  .react-calendar__navigation > .react-calendar__navigation__prev-button {
    order: 1;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 7px;
      left: 8px;
      width: 10px;
      height: 10px;
      border-right: 2px solid ${({ theme }) => theme.palette.brand400};
      border-bottom: 2px solid ${({ theme }) => theme.palette.brand400};
      transform: rotate(-225deg);
    }
  }

  .react-calendar__navigation > .react-calendar__navigation__next-button {
    order: 2;
    margin-left: 8px;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 7px;
      left: 5px;
      width: 10px;
      height: 10px;
      border-right: 2px solid ${({ theme }) => theme.palette.brand400};
      border-bottom: 2px solid ${({ theme }) => theme.palette.brand400};
      transform: rotate(-45deg);
    }
  }

  .react-calendar__navigation > .react-calendar__navigation__prev-button,
  .react-calendar__navigation > .react-calendar__navigation__next-button {
    position: relative;
    min-width: 24px;
    width: 24px;
    flex: 0 0 24px;
    height: 24px;
    text-indent: -100px;
    overflow: hidden;
  }

  .react-calendar__year-view__months__month {
    padding-top: 16px;
    padding-bottom: 16px;
    color: ${({ theme }) => theme.palette.grayscale400};
    ${({ theme }) => theme.typography('$headline_01')};
  }

  .react-calendar__month-view__weekdays__weekday {
    color: ${({ theme }) => theme.palette.grayscale600};
    text-decoration: none;
    ${({ theme }) => theme.typography('$caption_02')};
  }

  .react-calendar__navigation__prev2-button,
  .react-calendar__navigation__next2-button {
    display: none;
  }

  .react-calendar__month-view__days__day {
    height: 46px;
    cursor: pointer;
    color: ${({ theme }) => theme.palette.grayscale400};
    ${({ theme }) => theme.typography('$headline_01')};
    ${cssCalendarButton};

    &:disabled {
      opacity: 0.2;
    }

    &:hover {
      background: none !important;
    }
    &:active {
      background: none !important;
    }
    &:focus {
      background: none !important;
    }
    abbr {
      display: none;
    }

    .react-calendar--date-num {
    }
  }

  .react-calendar__tile--now {
    color: ${({ theme }) => theme.palette.brand400};
    font-weight: 500;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }

  .react-calendar__year-view__months__month {
    ${cssCalendarButton};
  }

  .react-calendar__tile--active {
    position: relative;
    color: #fff;

    &::after {
      content: '';
      width: 46px;
      height: 46px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.brand400};
      z-index: -1;
    }
  }
`;
